import { Report } from "@/types/nurse";
import { fetchAPI } from "@/utils/fetchAPI";

export type ProductName =
  | "Forfait avec Engagement"
  | "Gestion+ avec Engagement"
  | "Saisie PREMIER"
  | "Gestion+"
  | "eCofiCoffre";

type FetchCofidocReportParams = {
  dateStart: Date | string;
  dateEnd: Date | string;
  username?: string | null;
  email?: string | null;
};

// Extrait la date calendaire (jour/mois/année) LOCALE de la Date, sans passer par l'UTC.
// `dateStart`/`dateEnd` représentent un jour calendaire choisi localement (ex: le 1er du mois
// sélectionné) ; `toISOString()` réinterpréterait ce minuit local en UTC et décalerait la date
// d'un jour pour les fuseaux positifs (France métropolitaine).
function toDateOnlyString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export async function fetchCofidocReport({ dateStart, dateEnd, username, email }: FetchCofidocReportParams): Promise<Report[]> {
  try {
    const queryParams = new URLSearchParams();

    const dateStartStr = dateStart instanceof Date ? toDateOnlyString(dateStart) : dateStart;
    const dateEndStr = dateEnd instanceof Date ? toDateOnlyString(dateEnd) : dateEnd;

    queryParams.append("dateStart", dateStartStr);
    queryParams.append("dateEnd", dateEndStr);
    if (username) queryParams.append("username", username);
    if (email) queryParams.append("email", email);

    const queryString = queryParams.toString();
    const url = `/account/report?${queryString}`;

    const res = await fetchAPI({
      url,
      options: {
        method: "GET",
      },
    });
    // Si l'API retourne un seul objet Report, le wrapper dans un tableau
    // Si l'API retourne un tableau, le retourner directement
    if (!res) return [];
    
    const reports: Report[] = Array.isArray(res) ? res : [res];
    
    // Mapper les dates string en Date pour chaque report
    return reports.map((report) => ({
      ...report,
      date: new Date(report.date),
      dossiers: report.dossiers || [],
    }));
  } catch (error) {
    throw new Error();
  }
}
